export const technicianFileTabs = [
  {
    id: 'details',
    title: 'Details',
  },
  {
    id: 'service-area',
    title: 'Service Area',
  },
  {
    id: 'notes',
    title: 'Notes',
  },
  {
    id: 'jobs',
    title: 'Jobs',
  },
  {
    id: 'skillsets-service-types',
    title: 'Skillsets & Service Types',
  },
  {
    id: 'tickets',
    title: 'Tickets',
  },
  {
    id: 'availability',
    title: 'Availability',
  },
];
